<template>
  <div class="layout-main">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店长: </div>
            <ul class="item-list">
              <li @click="selectitem('user_id', item.id)" v-for="(item, index) in userList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店铺: </div>
            <ul class="item-list">
              <li @click="selectitem('store_id', item.id)" v-for="(item, index) in storeList" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">订单类型: </div>
            <ul class="item-list">
              <li @click="selectitem('type', item.value)" v-for="(item, index) in types" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">跟进人员: </div>
            <ul class="item-list">
              <li @click="selectitem('track_user_id', item.id)" v-for="(item, index) in traceUser" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.username}}</span></li>

            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">状态: </div>
            <ul class="item-list">
              <li @click="selectitem('status', item.value)" v-for="(item, index) in statuses" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>
            </ul>
          </li>
          <li v-if="false" class="list-group-item">
            <div class="item-label">搜索: </div>
            <Input v-model="searchval" style="width: 500px" >
                    <Select v-model="searchfield" slot="prepend" style="width: 80px">
                        <Option value="name">店铺名</Option>
                    </Select>
                    <Button @click="request" slot="append" icon="ios-search"></Button>
                </Input>
           
          </li>
        </ul>
      </div>
      <div class="tools">
        <Button @click="request" style="background: #1a242f" type="primary" icon="ios-refresh"></Button>
      </div>
      <Divider dashed />
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="products">
         
          <div v-for="(item, index) in row.order.products" :key="index" class="product-item">
            <div class="item-image">
              <img :src="item.item_image">
            </div>
            <div class="item-wrap">
              <p class="item-title">{{item.item_name}}</p>
              <p class="item-info">x{{item.item_quantity}} | {{item.item_sku}}</p>
            </div>
          </div>
        </template>
        <template slot-scope="{ row }" slot="ordersn">
          <strong>{{ row.order.ordersn }}</strong>
        </template>
        <template slot-scope="{ row }" slot="store">
          <strong>{{ row.store.name }}</strong>
        </template>
        <template slot-scope="{ row }" slot="type">
          <Select @on-change="(val)=>selectType(val, row.id, 'type')" v-model="row.order_type" style="width:200px">
              <Option v-show="item.value > 0" v-for="item in types" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row }" slot="status_text">
          <Select @on-change="(val)=>selectType(val, row.id, 'status')" v-model="row.status" style="width:200px">
              <Option v-for="item in statuses" :disabled="item.disabled" :value="item.value" :key="item.value">{{ item.name }}</Option>
          </Select>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Icon style="cursor: pointer;" size="20" title="备注" @click="showAddRemarkModal(row)" type="md-create" />&nbsp;
          <Icon style="cursor: pointer;" size="20" title="打开聊天" @click="openSession(row)" type="md-ionitron" />

        </template>
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
<Modal
    v-model="addRemarkModal"
    title="备注"
    :footer-hide="true"
    @on-cancel="addRemarkModal = false">

 <div>
   
   <div>
      <Form :model="remarkFormItem" :label-width="80">
       <FormItem label="备注">
        <quill-editor 
                  v-model="remarkFormItem.remark"
                  ref="myQuillEditor">
            </quill-editor>
       </FormItem>
       <FormItem>
           <Button @click="addRemark()" type="primary">添加</Button>
       </FormItem>
     </Form>
   </div>
 </div>
</Modal>
</div>

</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'; 
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: {
    quillEditor
  },

  data() {
    return {
      loading: false,
      addRemarkModal: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      userList: [],
      traceUser: [],
      storeList: [],
      filter: {
        connector: 'lazada',
        store_id: 0,
        type: 0,
        track_user_id: 0,
        status: 0
      },
      types: [
        {name: '全部', value: 0, active: true},
        {name: '常规', value: 1, active: false},
        {name: '退款', value: 2, active: false},
        {name: '紧急', value: 3, active: false},
        {name: '补发', value: 4, active: false},
        {name: '私下退换', value: 5, active: false},
      ],
      statuses: [
        {name: '待处理', value: 0, active: true, disabled: false},
        {name: '已完成', value: 1, active: false, disabled: false},
        {name: '-', value: 2, active: false, disabled: true},
      ],
      remarkFormItem: {
        id: '',
        remark: ''
      },
      columns: [
          {
              title: '买家昵称',
              key: 'buyer_username'
          },
          {
              title: '买家id',
              key: 'buyer_id'
          },
          {
              title: '店铺',
              slot: 'store'
          },
          {
              title: '备注',
              key: 'remark'
          },
          {
              title: '订单状态',
              slot: 'type'
          },
          {
              title: '状态',
              slot: 'status_text'
          },
          {
              title: '创建时间',
              key: 'short_time_text'
          },
          {
              title: '操作',
              slot: 'action',
              width: 150,
              align: 'center'
          }
      ],
      data: [
        
      ]
    }
  },
  computed: {
    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    }
  },
  methods: {
    // 店铺列表
    getStoreList () {
      let self = this;
      let param = new FormData();
      param.set("connector", this.filter.connector);
      if (this.filter.country) {
        param.set("country", this.filter.country);
      }
      if (this.filter.user_id) {
        param.set("ids", this.filter.user_id);
      }
      RequestUtils.request(conf.getStoreByUid(), param)
      .then(function (data) {
        self.storeList = data
        self.storeList.unshift({
          'id': 0,
          'name': '全部',
          'active': true
        })
      })
    },
    getUserList () {
      this.userList = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.userList.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    getTraceUser () {
      this.traceUser = JSON.parse(JSON.stringify(this.$store.state.childUser));
      this.traceUser.unshift({
        'id': 0,
        'username': '全部',
        'active': true
      })
    },
    setStatus(data) {
      if (data.status == 1) return false;
      let self = this;
      this.$Modal.confirm({
          title: '处理售后',
          content: '<p>确定将该订单设置为已解决吗?</p>',
          onOk: () => {

            let param = new FormData();
            param.set("id", data.id );
            param.set("connector", self.filter.connector );
            param.set("status", 1 );
            RequestUtils.request(conf.presalesStatus(), param)
            .then(() => {            
                this.$Message.success('操作成功!');
                self.request();
            })
          },
          onCancel: () => {
          }
      });
    },
    selectitem (key, value) {
      if (key == 'store_id') {
        for (let i=0; i<this.storeList.length; i++) {
          if (this.storeList[i].id == value) {
            this.storeList[i].active = true;
          } else {
            this.storeList[i].active = false;            
          }
        }
      } else if (key == 'type') {
        for (let i=0; i<this.types.length; i++) {
          if (this.types[i].value == value) {
            this.types[i].active = true;
          } else {
            this.types[i].active = false;
          }
        }
      } else if (key == 'track_user_id') {
        for (let i=0; i<this.traceUser.length; i++) {
          if (this.traceUser[i].id == value) {
            this.traceUser[i].active = true;
          } else {
            this.traceUser[i].active = false;
          }
        }
      } else if (key == 'user_id') {
        for (let i=0; i<this.userList.length; i++) {
          if (this.userList[i].id == value) {
            this.userList[i].active = true;
          } else {
            this.userList[i].active = false;
          }
        }
        this.filter[key] = value;
        this.getStoreList();
      }
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.data = [];
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let param = new FormData();
      param.set("page", this.curPage );
      param.set("connector", this.filter.connector );
      param.set('status', this.filter.status);
      if (this.filter.store_id) {      
        param.set("store_id", this.filter.store_id );
      }
      if (this.filter.type) {
        param.set('type', this.filter.type);
      }
      if (this.filter.track_user_id) {
        param.set('track_user_id', this.filter.track_user_id);
      }
      if (this.filter.user_id) {
        param.set('user_id', this.filter.user_id);
      }
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getPresalesList(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.data;
        console.log(data.data);
        self.loading = false;
      })
    },
    openSession(row) {
      this.$store.commit("lazada/openSession", {
        buyer_id: row.buyer_id,
        store_id: row.store_id
      });
    },
    showAddRemarkModal(item) {
      this.addRemarkModal = true;
      this.remarkFormItem.id = item.id;
      this.remarkFormItem.remark = item.remark;
    },
    addRemark() {
      let param = new FormData();
      param.set("connector", this.filter.connector );
      param.set("id", this.remarkFormItem.id );
      param.set("remark", this.remarkFormItem.remark );
      RequestUtils.request(conf.addPresaleRemark(), param)
      .then(() => {            
        this.remarkFormItem.remark = '';
        this.addRemarkModal = false;
        this.request();
      })
    },
    selectType(value, id, field) {
      let self = this;
      let param = new FormData();
      param.set("id", id );
      param.set(field, value );
      param.set("connector", this.filter.connector );
      RequestUtils.request(conf.changePsalesStatus(), param)
      .then(() => {            
        self.$Message.success('设置成功!');
        self.request();
      })
    },
  },

  created() {
    this.getStoreList()
    this.getUserList()
    this.getTraceUser()
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}

.product-item {
  display:flex;
  padding: 5px 0px;

  .item-image {
    img {
      width: 50px;
      height: 50px;
    }
  }
  .item-wrap {
    padding-left: 10px;

    .item-title {
      max-width: 150px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap; 
      font-weight:bold;
    }
  }
}

.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;
      flex: 1;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
